module.exports = __webpack_public_path__ + "images/3d87a22b234d57926b845e1db2b55303.svg";